import React, {Fragment} from 'react';

import './TransactionPendingFiltersV2.scss';
import {AAMBeaconButton, AAMBeaconControl} from "components/shared/Beacon";

const TransactionPendingFiltersV2 = ({
                                         filterOptions = {}
}) => {
    // Set up event listeners for the filtering options to capture selection changes
    // useEffect(() => {
    //
    // }, [])

    console.log(filterOptions);

    return (
        <Fragment>
            <div className='b-grid b-margin-block-end--macro--mini'>
                <div className='b-grid-item--3-col'>
                    <AAMBeaconControl>
                        <label slot="label" htmlFor="transaction-pending-status">
                            Status
                        </label>
                        <select id="transaction-pending-status" name="transaction-pending-status" aria-invalid="false" aria-disabled="false">
                            return <option value={'all'}>All Status</option>
                        </select>
                    </AAMBeaconControl>
                </div>
                <div className='b-grid-item--3-col'>
                    <AAMBeaconControl>
                        <label slot="label" htmlFor="transaction-pending-symbol-cusip">
                            Symbol/CUSIP
                        </label>
                        <input
                            type="text"
                            id={'transaction-pending-symbol-cusip'}
                            name={'transaction-pending-symbol-cusip'}
                            value={''}
                        />
                    </AAMBeaconControl>
                </div>
                <div className='align-center b-grid-item--2-col'>
                    <AAMBeaconButton
                        className="pending-transactions-apply-filters-button"
                        variant="secondary"
                        scale="mini"
                        aria-label="apply filters button"
                        data-testid="beacon-appli-filters-button"
                    >
                        Apply Filters
                    </AAMBeaconButton>
                </div>
            </div>
        </Fragment>
    );
};

export default TransactionPendingFiltersV2;
